"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoIconRow = exports.InfoIconContainer = void 0;
const styled_1 = __importDefault(require("../../styles/styled"));
const styled_system_1 = require("styled-system");
const layout_1 = require("../layout");
exports.InfoIconContainer = styled_1.default.div(({ theme }) => {
    return {
        border: `1px solid ${theme.colors.grey90}`,
        borderRadius: '100px',
        display: 'inline-block',
    };
}, styled_system_1.space);
exports.InfoIconRow = (0, styled_1.default)(layout_1.Row)({
    justifyContent: 'start',
    alignItems: 'center',
}, styled_system_1.space);
//# sourceMappingURL=info_icon.styles.js.map